import moment from "moment";

// Deberia llamarse humanizeTime
export function humanizeDate(value) {
    return moment(value).format("Y-MM-DD hh:mm a")
}

export function _humanizeDate(value) {
    if (value !== null || value !== '') {
        return moment(value).format("Y-MM-DD")
    }
    return "";
}


export function fromNowDate(value) {
    moment.locale("es");
    return moment(value).endOf('day').fromNow()
}
